<template>
  <v-speed-dial
    v-if="show"
    v-model="fab"
    :direction="direction"
    :transition="transition"
    fixed
    bottom
    right
    class="speed-dial"
  >
    <template v-slot:activator>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="black" dark fab v-on="on">
            <v-icon>{{ fab ? 'mdi-close' : 'mdi-dots-vertical' }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t('$vuetify.QUICK_ACTIONS.TOOLTIP') }}</span>
      </v-tooltip>
    </template>
    <div class="speed-dial-buttons">
      <v-btn
        v-for="(quickAction, index) in quickActions"
        :key="index"
        dark
        color="black"
        @click="() => handleQuickActionClick(quickAction)"
      >
        <v-icon left>mdi-boom-gate</v-icon>
        {{ quickAction.Text[$vuetify.lang.current] }}
      </v-btn>
    </div>
  </v-speed-dial>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'QuickActions',
  data: () => ({
    expandOnHover: false,
    fab: false,
    direction: 'top',
    transition: 'scale-transition'
  }),
  computed: {
    ...mapGetters('app', ['loading', 'quickActions']),
    show: {
      get() {
        return Array.isArray(this.quickActions) && this.quickActions.length > 0
      }
    }
  },
  async created() {
    await this.getQuickActions({ this: this })
  },
  methods: {
    ...mapActions('app', ['getQuickActions', 'postQuickAction']),
    async handleQuickActionClick(item) {
      await this.postQuickAction({ this: this, item })
    }
  }
}
</script>

<style>
.speed-dial {
  bottom: 16px;
  right: 16px;
}
.speed-dial-buttons {
  position: absolute;
  right: 0;
  bottom: 12px;
}
</style>
